import React from 'react'
import { IIconProps as IProps } from './IIconProps'

const IconDownload = (props: IProps) => (
  <svg
    style={{
      width: `${props.size}px`,
      height: `${props.size}px`,
    }}
    viewBox="0 0 60 60"
  >
    <path
      d="M6.39669 23.0695C8.25894 21.2493 11.2782 21.2493 13.1405 23.0695L23.9246 33.6096C24.4556 34.1287 25.3636 33.7611 25.3636 33.0271L25.3636 4.5315C25.3636 2.02882 27.4394 0 30 0C32.5606 0 34.6364 2.02882 34.6364 4.5315L34.6364 33.0271C34.6364 33.7611 35.5444 34.1287 36.0754 33.6096L46.8595 23.0695C48.7218 21.2493 51.7411 21.2493 53.6033 23.0695C55.4656 24.8896 55.4656 27.8406 53.6033 29.6607L34.7686 48.0695C33.4531 49.3552 31.7293 49.9987 30.0051 50H55C57.7614 50 60 52.2386 60 55C60 57.7614 57.7614 60 55 60H5C2.23858 60 0 57.7614 0 55C0 52.2386 2.23858 50 5 50H29.9949C28.2707 49.9987 26.5469 49.3552 25.2314 48.0695L6.39669 29.6607C4.53444 27.8406 4.53444 24.8896 6.39669 23.0695Z"
      fill={props.color}
    />
  </svg>
)

export default IconDownload
